import { AlertTriangle } from "lucide-react";
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

/** Faixa amarela na aba Impressão quando o cupom de preparo está desligado em
 *  Preferências — senão a pessoa escolhe impressora de preparo e nada sai. */
export default function AvisoPreparoDesligado() {
  const [desligado, setDesligado] = useState(false);
  useEffect(() => {
    fetch(`${API_URL}/api/settings/preparo`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
      cache: "no-store",
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setDesligado(d?.ativo === false))
      .catch(() => {});
  }, []);

  if (!desligado) return null;
  return (
    <div className="flex items-start gap-3 rounded-xl border border-amber-400/60 bg-amber-50 dark:bg-amber-500/10 px-4 py-3" data-e2e="aviso-preparo-desligado">
      <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
      <p className="text-sm text-amber-900 dark:text-amber-200">
        <span className="font-semibold">O cupom de preparo está desligado para a loja inteira.</span>{" "}
        Nenhum computador imprime o preparo, mesmo com impressora escolhida aqui. Para voltar a imprimir:
        Configurações → Sistema → Preferências → "Imprimir cupom de preparo".
      </p>
    </div>
  );
}
